import { API_URL } from "../api-config";

export let socketPF = null;
const subscribers = new Map(); // subscriberUID -> callback

function getWebSocketURL(apiURL) {
    const isSecure = apiURL.startsWith('https://');
    const wsProtocol = isSecure ? 'wss' : 'ws';

    const wsURL = apiURL.replace(/^https?:\/\//, '');
    // Endpoint para el nuevo usdclp-api
    return `${wsProtocol}://${wsURL}/usdclp-api/price/ws`;
}

export function connectWebSocketPF() {
    const websocketURL = getWebSocketURL(API_URL);
    console.log('Connecting to Price Feed WebSocket:', websocketURL);
    socketPF = new WebSocket(websocketURL);

    socketPF.onopen = () => {
        console.log('Price Feed WebSocket Connected');
        reconnectAttempts = 0;
    };

    socketPF.onmessage = (event) => {
        const message = JSON.parse(event.data);
        // console.log('Price Feed WebSocket Message:', message);
        if (message.type === 'ping') {
            if (socketPF.readyState === WebSocket.OPEN) {
                socketPF.send(JSON.stringify({ type: "pong" }));
            }
        } else if (message.type === 'puntas_mid' || message.mid) {
            handleNewTick(message);
        }
    };

    socketPF.onerror = (error) => {
        console.error('Price Feed WebSocket Error:', error);
        scheduleReconnect();
    };

    socketPF.onclose = (event) => {
        console.log('Price Feed WebSocket Disconnected', event);
        scheduleReconnect();
    };
}

let reconnectAttempts = 0;

function scheduleReconnect() {
    setTimeout(() => {
        if (reconnectAttempts < 8) {
            connectWebSocketPF();
            reconnectAttempts++;
        }
    }, Math.pow(2, reconnectAttempts) * 1000);
}

function handleNewTick(tickData) {
    if (tickData && tickData.timestamp && tickData.mid) {
        const time = Math.floor(tickData.timestamp * 1000);
        const formattedTick = {
            time: time,
            low: tickData.mid,
            high: tickData.mid,
            open: tickData.mid,
            close: tickData.mid,
            volume: 0
        };
        console.log('[Price Feed WebSocket] Broadcasting tick:', formattedTick.time, formattedTick.close);

        subscribers.forEach((callback) => {
            callback(formattedTick);
        });
    }
}

export function closeWebSocketPF() {
    if (socketPF) {
        socketPF.close();
        socketPF = null;
    }
}

export function subscribePriceFeed(subscriberUID, callback) {
    subscribers.set(subscriberUID, callback);
}

export function unsubscribePriceFeed(subscriberUID) {
    subscribers.delete(subscriberUID);
}

export function getSubscriberCountPF() {
    return subscribers.size;
}
